module.exports = __webpack_public_path__ + "img/logo-mobile.52d91f45.svg";